// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"468":"40f43b6c","718":"68cdde2a","840":"2f0edb06"}[chunkId] + ".chunk.css";
};